import { Injectable, ViewContainerRef } from '@angular/core';
import { Modal, BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { PlayerModalComponent } from './player-modal.component';
import { overlayConfigFactory } from 'ngx-modialog';

@Injectable()
export class PlayerModalService {
    constructor(public modal: Modal) {}

    openDialog(strImgURL: string, viewContainer:ViewContainerRef) {
    	(this.modal.overlay as any).defaultViewContainer = viewContainer;
        return this.modal.open(PlayerModalComponent, overlayConfigFactory({strImgURL: strImgURL}, BSModalContext));
    };
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/player-modal/player-modal.service.ts